
import { nextTick } from 'vue'
import {useViewTags} from "@/layout/components/viewTags";
const tags = useViewTags()
export function beforeEach(to, from,next){
	var adminMain = document.querySelector('#adminui-main')
	if(!adminMain){return true}
	// store.commit("updateViewTags", {
	// 	fullPath: from.fullPath,
	// 	scrollTop: adminMain.scrollTop
	// })
	tags.update({
			fullPath: from.fullPath,
			scrollTop: adminMain.scrollTop
		}
	)
	return true
}

export function afterEach(to){
	const adminMain = document.querySelector('#adminui-main')
	if(!adminMain){return false}
	nextTick(()=>{
		const beforeRoute = tags.tags.filter(v => v.fullPath === to.fullPath)[0]
		if(beforeRoute){
			adminMain.scrollTop = beforeRoute.scrollTop || 0
		}
	})
}
